export default "__VITE_ASSET__DTpI6gPG__"